import { render, staticRenderFns } from "./areaCascader.vue?vue&type=template&id=322da84d"
import script from "./areaCascader.vue?vue&type=script&lang=js"
export * from "./areaCascader.vue?vue&type=script&lang=js"
import style0 from "./areaCascader.vue?vue&type=style&index=0&id=322da84d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports